import type { Theme } from '@mui/material/styles';
import type { SxStyles } from '@/ui/style/types';

/**
 * Gets custom sx classes for the checkbox list component.
 *
 * @param theme - The MUI theme object
 * @returns The sx classes object
 */
export const getSxClasses = (theme: Theme): SxStyles => ({
  list: {
    padding: theme.spacing(0),
  },
  typography: {
    padding: theme.spacing(0),
  },
  listItem: {
    height: '28px',
    padding: theme.spacing(0),
    color: theme.palette.secondary.contrastText,
  },
  listItemButton: {
    height: '100%',
    padding: theme.spacing(0),
    '&:hover': {
      // Keep the hover background visible on touch, where MUI resets it to transparent.
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.dark,
    },
  },
  listItemIcon: {
    minWidth: '0px',
  },
  boxcontent: {
    padding: theme.spacing(0),
  },
});
